const MAX_PROGRESS = 150
const MAX_TUNNEL_WIDTH = 85
const MIN_TUNNEL_WIDTH = 20

export function getTunnelWidth(progress: number): string {
  const ratio = (MAX_PROGRESS - progress) / MAX_PROGRESS
  return `${ratio * MAX_TUNNEL_WIDTH + MIN_TUNNEL_WIDTH}%`
}
